var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnyIssues = function SvgAnyIssues(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m17 7-3-3m9 3 3-3m-9 9-3 3m9-3 3 3m3-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-5 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M18 23c0 .53-.199 1.04-.553 1.414A1.84 1.84 0 0 1 16.11 25H4.778L1 29V13c0-.53.199-1.04.553-1.414A1.84 1.84 0 0 1 2.89 11H16.11c.501 0 .982.21 1.336.586.354.375.553.884.553 1.414z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M17 13c0-.283-.107-.544-.28-.727A.84.84 0 0 0 16.11 12H2.89a.84.84 0 0 0-.609.273c-.173.183-.28.444-.28.727v13.484l2.05-2.17.075-.072A1 1 0 0 1 4.777 24h11.334c.217 0 .437-.09.609-.273.173-.183.28-.444.28-.727zm2 10a3.06 3.06 0 0 1-.826 2.1c-.537.569-1.278.9-2.063.9H5.21l-3.482 3.686A1 1 0 0 1 0 29V13c0-.778.291-1.534.826-2.1A2.84 2.84 0 0 1 2.89 10H16.11c.785 0 1.526.331 2.063.9A3.06 3.06 0 0 1 19 13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M4 17h1v-2h1v5H5v-2H4v2H3v-5h1zm5.5-1h-2v1h1v1h-1v1h2v1h-3v-5h3zm1.5 3h1.5v1H10v-5h1zm5-4v3h-2v2h-1v-5zm-2 2h1v-1h-1z"
  })));
};
export default SvgAnyIssues;